"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_POSITIONS = exports.SIGN_POST_POSITIONS = void 0;
const Popover_1 = require("../../Popover");
exports.SIGN_POST_POSITIONS = {
    topRight: { xAxis: Popover_1.X_AXIS.insideLeft, yAxis: Popover_1.Y_AXIS.outsideTop, offsetX: 5, offsetY: -8 },
    topLeft: { xAxis: Popover_1.X_AXIS.outsideLeft, yAxis: Popover_1.Y_AXIS.outsideTop, offsetX: 10, offsetY: -8 },
    bottomRight: { xAxis: Popover_1.X_AXIS.insideLeft, yAxis: Popover_1.Y_AXIS.outsideBottom, offsetX: 6, offsetY: 8 },
    bottomLeft: { xAxis: Popover_1.X_AXIS.outsideLeft, yAxis: Popover_1.Y_AXIS.outsideBottom, offsetX: 10, offsetY: 8 },
    right: { xAxis: Popover_1.X_AXIS.outsideRight, yAxis: Popover_1.Y_AXIS.insideTop, offsetX: 8, offsetY: 0 },
    left: { xAxis: Popover_1.X_AXIS.outsideLeft, yAxis: Popover_1.Y_AXIS.insideTop, offsetX: -8, offsetY: 0 }
};
exports.DEFAULT_POSITIONS = [
    exports.SIGN_POST_POSITIONS.topRight,
    exports.SIGN_POST_POSITIONS.topLeft,
    exports.SIGN_POST_POSITIONS.bottomRight,
    exports.SIGN_POST_POSITIONS.bottomLeft,
    exports.SIGN_POST_POSITIONS.right,
    exports.SIGN_POST_POSITIONS.left
];
//# sourceMappingURL=SignPostPositions.js.map